import { Component } from 'react';

// Keeps an optional widget's crash from taking down the page (R0: the chat
// widget must never break the site). Renders `fallback` (default: nothing).
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error('Widget crashed (hidden by ErrorBoundary):', error);
  }

  render() {
    if (this.state.failed) return this.props.fallback ?? null;
    return this.props.children;
  }
}
